let scrollPosition = 0

const $modal = document.querySelector('.select-packages__modal')
const $selectPackagesOpenBtn = document.querySelector(
  '.select-packages__open-btn'
)
const $selectPackagesCloseBtn = document.querySelector(
  '.select-packages__close-btn'
)

if ($selectPackagesOpenBtn) {
  $selectPackagesOpenBtn.addEventListener('click', function () {
    scrollPosition = window.scrollY
    document.body.style.position = 'fixed'
    document.body.style.top = `-${scrollPosition}px`
    document.body.style.width = '100%'
  })
}

if ($selectPackagesCloseBtn) {
  $selectPackagesCloseBtn.addEventListener('click', function () {
    document.body.style.position = ''
    document.body.style.top = ''
    window.scrollTo(0, scrollPosition)
  })
}

if ($modal) {
  const observer = new MutationObserver(() => {
    if (!$modal.classList.contains('is-active')) {
      document.body.style.position = ''
      document.body.style.top = ''
      window.scrollTo(0, scrollPosition)
    }
  })
  observer.observe($modal, { attributes: true, attributeFilter: ['class'] })
}
